import { SvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const MessageIcon: FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.654 7.375C7.35713 7.375 7.86494 7.96094 7.86494 8.625C7.86494 9.32812 7.31807 9.875 6.654 9.875C5.98994 9.875 5.44307 9.32812 5.44307 8.625C5.44307 7.96094 5.95088 7.375 6.654 7.375ZM11.029 7.375C11.7321 7.375 12.2399 7.96094 12.2399 8.625C12.2399 9.32812 11.7321 9.875 11.029 9.875C10.3259 9.875 9.779 9.32812 9.779 8.625C9.779 7.96094 10.3259 7.375 11.029 7.375ZM15.404 7.375C16.1071 7.375 16.6149 7.96094 16.6149 8.625C16.6149 9.32812 16.0681 9.875 15.404 9.875C14.7399 9.875 14.1931 9.32812 14.1931 8.625C14.1931 7.96094 14.7009 7.375 15.404 7.375ZM18.4509 0.5C19.8571 0.5 20.9509 1.63281 20.9509 3V14.1719C20.9509 15.5 19.8181 16.6328 18.4509 16.6328H12.8259L7.94307 20.3047C7.63057 20.5 7.20088 20.3047 7.20088 19.9141V16.6719H3.45088C2.04463 16.6719 0.950879 15.5781 0.950879 14.2109V3C0.950879 1.63281 2.04463 0.5 3.45088 0.5H18.4509ZM19.1149 14.25V3C19.1149 2.6875 18.8024 2.375 18.4899 2.375H3.48994C3.13838 2.375 2.86494 2.6875 2.86494 3V14.25C2.86494 14.6016 3.13838 14.875 3.48994 14.875H9.11494V17.2188L12.2399 14.875H18.4899C18.8024 14.875 19.1149 14.6016 19.1149 14.25Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default MessageIcon;
